const parseaFechaHora = (datoFecha, literalFecha = "HH:mmh - DD/MM/YY") => {
  if (datoFecha) {
    const parts = datoFecha.match(/(.{1,2})/g);
    const mes = parts[0];
    const dia = parts[1];
    const hora = parts[2];
    const minuto = parts[3];
    const anoActual = new Date().getFullYear();

    let txt = literalFecha;
    txt = txt
      .replace('YY', anoActual)
      .replace('MM', mes)
      .replace('DD', dia)
      .replace('HH', hora)
      .replace('mm', minuto);
    return txt;
  } else return literalFecha;
};

export default parseaFechaHora;
